import { Outlet } from "react-router-dom";
import PageDepth2 from "../components/PageDepth2";
import styles from '../styles/Performance.module.css';
import data from '../data/data.json'
import classNames from "classnames/bind";
import PageTitle from "../components/PageTitle";

const cx = classNames.bind(styles);

//업무분야 및 실적
export default function Performance() {

  const performanceCategory = data.category.find(
    (category) => category.path === "performance"
  )

  return (
    <>
      <PageTitle title={performanceCategory.label} image={performanceCategory.image}/>

      <PageDepth2 pagedepth2={performanceCategory.children} />

      <Outlet/>
    </>
  );
}

